import { render, staticRenderFns } from "./TableCellTypeRelationshipOneToMany.vue?vue&type=template&id=c0e19b5e&scoped=true"
import script from "./TableCellTypeRelationshipOneToMany.vue?vue&type=script&lang=js"
export * from "./TableCellTypeRelationshipOneToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e19b5e",
  null
  
)

export default component.exports